import React from 'react';
import { useWrapRequest } from 'use-wrap-request';
import { useNavigate, useParams } from 'react-router';
import { TenantCorporateContext } from '..';
import { userSearchDebounce } from '../../components/hooks/use-search';
import { useSearchReducer } from '../../components/hooks/useSearchReducer';
import { CellProps, TableComponent } from '../../components/table';
import { EmployeeDto } from '../../core/api/CorporateClient';
import { links } from '../../core/router';
import { CopyEmailButton } from '../copy-email-button';

export const TenantEmployees = () => {
    const corporateClient = React.useContext(TenantCorporateContext);
    const [searchParams, dispatch] = React.useReducer(useSearchReducer, {
        size: 30,
        page: 0
    });
    const { setSearchTerm } = userSearchDebounce(dispatch);
    const navigate = useNavigate();
    const { tenantName } = useParams();

    const employees = useWrapRequest(
        async (searchParams) => {
            const result =
                await corporateClient.support.employeeSupportControllerGetPage(
                    searchParams
                );

            return { ...result.data, content: result.data.content || [] };
        },
        {
            defaultData: { content: [] },
            deps: [searchParams]
        }
    );

    return (
        <TableComponent<EmployeeDto[]>
            items={employees}
            contextMenu={[
                {
                    label: 'Details',
                    hidden: (value) => !value.id,
                    action: (value) => {
                        if (value.id) {
                            navigate(
                                links.tenantEmployeeDetails(
                                    tenantName,
                                    value.id.toString()
                                )
                            );
                        }
                    }
                },
                {
                    label: 'Activities',
                    hidden: (value) => !value.id,
                    action: (value) => {
                        if (value.id) {
                            navigate(
                                links.tenantEmployeeActivities(
                                    tenantName,
                                    value.id.toString()
                                )
                            );
                        }
                    }
                },
                {
                    label: 'Facilities',
                    hidden: (value) => !value.id,
                    action: (value) => {
                        if (value.id) {
                            navigate(
                                links.tenantEmployeeFacilities(
                                    tenantName,
                                    value.id.toString()
                                )
                            );
                        }
                    }
                }
            ]}
            columns={[
                { Header: 'First Name', accessor: 'firstName' },
                { Header: 'Last Name', accessor: 'lastName' },
                {
                    Header: 'Email',
                    style: { width: '50%' },
                    Cell: ({
                        row: {
                            original: { email }
                        }
                    }: CellProps<EmployeeDto>) => (
                        <CopyEmailButton email={email} />
                    )
                }
            ]}
            onSearchChange={(val) => void setSearchTerm(val)}
            onPageSizeChange={(size) => dispatch({ type: 'size', size })}
            onChangePage={(page) => void dispatch({ type: 'page', page })}
        />
    );
};

export default TenantEmployees;
